import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Subtitles } from '../Tracks.types';

export const useAddEmptyOption = (
    tracks: readonly Subtitles[],
    isSubtitlesToggleEnabled: boolean
): readonly Subtitles[] => {
    const hasTextTracks = tracks.length > 0;

    const isForcedSubtitles = !isSubtitlesToggleEnabled && hasTextTracks;

    const intl = useIntl();

    const disableOption = useMemo<Subtitles>(
        () => ({
            name: intl.formatMessage({
                id: 'components.PlayerSkin.d15305d7a4e34e02489c74a5ef542f36',

                defaultMessage: 'Off',
                description: 'Кнопка отключения субтитров',
            }),
            value: '',
            lang: '',
            disabled: isForcedSubtitles,
            note: isForcedSubtitles
                ? intl.formatMessage({
                      id: 'components.PlayerSkin.b90d6af3d7948f8ab5d5872bcc3425ed',

                      defaultMessage: "Can't disable due to copyright holders' requirement",
                      description:
                          'Надпись, которая появляется при попытке выключить субтитры, когда они включены по требованию правообладателей',
                  })
                : undefined,
        }),
        [intl, isForcedSubtitles]
    );

    return useMemo(() => [disableOption, ...tracks], [disableOption, tracks]);
};
